import React from 'react';
import { useTranslation } from 'next-i18next';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Separator,
  Button,
  H5,
  Muted,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import Textarea from '@components/UI/atoms/form/Textarea';
import RadioInputs from '@components/UI/atoms/form/RadioInputs';
import ModalMessage from '@components/UI/organisms/ModalMessage';
import type { ReportIssueModalProps } from './report-issue-modal.types';

export const ReportIssueModal = ({
  selectedIssue,
  comment,
  issueOptions,
  isSubmitting,
  message,
  messageType,
  onIssueTypeChange,
  onCommentChange,
  onSubmit,
  onCancel,
}: ReportIssueModalProps) => {
  const { t } = useTranslation('common');

  const issueSelectProps = {
    options: issueOptions,
    className: '',
    id: 'edit-proficiency',
    value: selectedIssue,
    name: 'issue-type',
    updateHandler: onIssueTypeChange,
    invalidLabel: true,
    onKeyDown: onSubmit,
  };

  const issueCommentProps = {
    rows: 5,
    value: comment,
    updateHandler: onCommentChange,
    className:
      'max-w-lg shadow-sm block w-full sm:text-sm border border-light-gray rounded-md py-2 px-4',
  };

  return (
    <div className="max-w-xl mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('modals.issue.report.title')}</CardTitle>
          <button type="button" className="modal-close" onClick={onCancel}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <form
            method="post"
            className="report-issue-form"
            onSubmit={onSubmit}
            noValidate
          >
            <div>
              <div className="reasons-wrapper">
                <H5>{t('modals.issue.report.labelSelectIssue')}</H5>
                <RadioInputs {...issueSelectProps} />
              </div>
              <div className="message-wrapper mt-8">
                <H5 className="mb-4">{t('modals.issue.report.labelComment')}</H5>
                <Textarea {...issueCommentProps} />
              </div>
              <Muted className="mt-6">{t('modals.issue.report.warning')}</Muted>
            </div>
            <Separator className="my-4" />
            <div className="text-right">
              <Button size="lg" disabled={isSubmitting} onClick={onSubmit}>
                {t('links.report')}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
